// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jijQ","field":"styles_field__1vqT6","fieldCol":"styles_fieldCol__1xh_i","diffCol":"styles_diffCol__13E5T","diff":"styles_diff__2cvgI"};